import { provideAppInitializer, inject, EnvironmentProviders } from '@angular/core';
import { LocaleService } from './locale.service';

export const provideLocaleInitializer = (): EnvironmentProviders =>
  provideAppInitializer(() => {
    const localeService = inject(LocaleService);
    localeService.initialize(localeService.resolveInitialLocale());
  });
